import { Injectable } from '@angular/core';
import {
  ITestTemplate,
  ITestUser,
} from '@g99-product-web-ui/shared-interface-lib';
import { API_ENDPOINTS } from '@g99-product-web-ui/shared-util-lib';
import { Observable } from 'rxjs';

import { HttpService } from '../../core/http-service/http.service';

@Injectable({
  providedIn: 'root',
})
export class TestTemplateService {
  constructor(private readonly _httpService: HttpService) {}
  public getContactSubmissions(): Observable<ITestUser[]> {
    const url = API_ENDPOINTS.TEMPLATE_ENDPOINTS.getContactSubmissions;
    return this._httpService.get<ITestUser[]>(url);
  }

  public testEmailTemplate(payload: ITestTemplate): Observable<ITestTemplate> {
    const url = API_ENDPOINTS.TEMPLATE_ENDPOINTS.testEmailTemplate;
    return this._httpService.post(url, payload);
  }

  public testSmsTemplate(payload: ITestTemplate): Observable<ITestTemplate> {
    const url = API_ENDPOINTS.TEMPLATE_ENDPOINTS.testSmsTemplate;
    return this._httpService.post(url, payload);
  }
}
